import React from 'react';
import { Commons } from 'components';

/**
 * 김앤장 식대 사용 통계 리스트 컴포넌트
 * @param {Object} props
 * @param {Object} props.listFn - 페이지네이션 관련 함수와 상태
 * @param {number} props.listFn.page - 현재 페이지 번호
 * @param {number} props.listFn.pageRow - 페이지당 행 수
 * @param {number} props.listFn.totalCount - 전체 데이터 수
 * @param {Function} props.listFn.pageClick - 페이지 클릭 핸들러
 * @param {Object} props.usageStat - 사용 통계 데이터
 */
const KimAndChangStatsList = ({ listFn, usageStat }) => {
  // 기본 테이블 컬럼 정의
  const defaultTable = [
    { name: '날짜', property: 'useDate' },
    { name: 'ID', property: 'signId' },
    { name: '이름', property: 'name' },
    { name: '사번', property: 'comIdNum' },
    { name: '휴대전화번호', property: 'cellphone' },
    { name: '총사용식대', property: 'totalPrice' },
    { name: '회사지원금액', property: 'companySupportPrice' },
    { name: '개인사용금액', property: 'salaryDeductionPrice' },
    { name: '개인사용공급가액', property: 'personalSupplyAmount' },
    { name: '개인사용부가세', property: 'personalVatAmount' }
  ];

  // usageStat이 null인 경우 빈 데이터로 초기화
  const { stat, total, table = defaultTable } = usageStat?.data || {
    stat: null,
    total: null,
    table: defaultTable
  };

  // 현재 페이지에 해당하는 데이터만 추출
  const getCurrentPageData = () => {
    if (!stat) return null;
    const startIndex = (listFn.page - 1) * listFn.pageRow;
    const endIndex = startIndex + listFn.pageRow;
    return stat.slice(startIndex, endIndex);
  };

  const currentPageData = getCurrentPageData();

  // 우측 정렬이 필요한 컬럼들의 property 목록
  const rightAlign = [
    'couponmember',
    'couponcount',
    'paycount',
    'salesprice',
    'companyprice',
    'companysupportprice',
    'salarydeductionprice',
    'totalprice',
    'personalsupplyamount',
    'personalvatamount'
  ];

  // TableForm에 맞는 데이터 구조로 변환
  const tabledata = {
    header: {
      main: table.map((col) => ({
        data: col.name,
        textAlign: rightAlign.includes(col.property.toLowerCase()) ? 'right' : 'left'
      })),
      // table 컬럼 정의를 기준으로 total 데이터 표시
      sub: table.map((col, index) => {
        // 첫번째 컬럼은 항상 '합계' 표시
        if (index === 0) {
          return {
            data: '합계',
            textAlign: 'left'
          };
        }

        // table 컬럼의 정렬 기준 확인
        const isRightAlign = rightAlign.includes(col.property.toLowerCase());

        // total 데이터가 있고 해당 property가 존재하는 경우에만 값 표시
        const totalValue = total && col.property in total ? total[col.property] : null;

        return {
          data: totalValue?.toLocaleString() || '-',
          textAlign: isRightAlign ? 'right' : 'left'
        };
      })
    },
    body: {
      message: stat === null ? '검색 버튼을 클릭하여 통계를 조회하세요.' : '식사 사용 통계 내역이 존재하지 않습니다.',
      main: currentPageData?.map((row) => ({
        row: table.map((col) => ({
          data: row[col.property]?.toLocaleString() || '-',
          textAlign: rightAlign.includes(col.property.toLowerCase()) ? 'right' : 'left'
        }))
      }))
    }
  };

  return (
    <>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '4px 0px'
      }}>
        <span style={{ fontWeight: 700 }}>검색결과 {listFn?.totalCount || 0}건</span>
      </div>
      <div className="table-box">
        <Commons.TableForm tabledata={tabledata} />
      </div>
      <div className="table-paging">
        <Commons.Pagination
          page={listFn.page}
          pageRow={listFn.pageRow}
          pageBlock={10}
          totalCount={stat?.length || 0}
          pageClick={listFn.pageClick}
        />
      </div>
    </>
  );
};

export default KimAndChangStatsList;
